var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.visible
        ? _c(
            "Modal2",
            {
              attrs: {
                showFooter: false,
                showTitle: false,
                className: "subscription-management-modal",
              },
              on: { cancel: _vm.onCancel },
            },
            [
              _c("div", { staticClass: "subscription-management-container" }, [
                _c("div", { staticClass: "plans-header" }, [
                  _c("h3", { staticClass: "plans-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.paidSubscriptions"))),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "plans-list-new" },
                  _vm._l(_vm.plansList, function (item) {
                    return _c(
                      "div",
                      { key: item.currentPlan._id, staticClass: "plan-card" },
                      [
                        _c("div", { staticClass: "left" }, [
                          _c(
                            "div",
                            { staticClass: "icon-wrapper" },
                            [
                              _c("DynamicSvg", {
                                attrs: {
                                  name: _vm.getIconName(item.plan.type),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "labels" }, [
                            _c("div", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.getTitle(item.plan.type))),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "chips" }, [
                              _c("span", { staticClass: "chip" }, [
                                _vm._v(
                                  _vm._s(_vm.periods[item.currentPlan.period])
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.getQuantity(item).total > 0
                                ? _c("span", { staticClass: "chip" }, [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(_vm.getQuantity(item).total) +
                                        "\n                                    " +
                                        _vm._s(
                                          _vm.getQuantityText(item.plan.type)
                                        ) +
                                        "\n                                "
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            _c(
                              "SupsisButton",
                              {
                                attrs: { danger: "", size: "small" },
                                on: {
                                  click: function ($event) {
                                    return _vm.tryCancel(item)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$t("message.cancelSubscription")
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showCancelResourcesModal
        ? _c("CancelPlanResourcesModal", {
            attrs: {
              visible: _vm.showCancelResourcesModal,
              plan: _vm.cancelItem ? _vm.cancelItem.plan : {},
            },
            on: {
              close: function ($event) {
                _vm.showCancelResourcesModal = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }